// @ts-ignore
import isNil from './isNil';

interface Headers {
  [index: string]: string;
}

// returns an object of the API options for an ajax request.
export default function apiAjaxOptions(
  method: string,
  additionalHeaders?: { key: string; value: string }[] | null,
  body?: BodyInit | null,
  content_type?: string,
  // Not 'include': that credentials cross-origin calls too, and browsers then
  // reject the wildcard CORS header on our anonymous admin.<domain> requests.
  credentials: RequestCredentials = 'same-origin'
) {
  // CSRF Token
  var csrfTokenValue = '';
  if (document.getElementsByName('authenticity_token')[0] != null) {
    csrfTokenValue = (document.getElementsByName(
      'authenticity_token'
    )[0] as HTMLInputElement).value;
  }
  if (
    document.querySelector('meta[name="csrf-token"]') != null &&
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute('content') != null
  ) {
    csrfTokenValue =
      document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute('content') || '';
  }

  let headers: Headers = {
    Accept: 'application/json',
    'X-CSRF-Token': csrfTokenValue,
  };

  // New versions of IE throw a Type Mismatch error if headers are an empty string
  if (isNil(csrfTokenValue)) {
    delete headers['X-CSRF-Token'];
  }

  if (content_type !== 'multipart/form-data') {
    headers['content-type'] = 'application/json';
  }
  if (content_type === 'application/octet-stream') {
    headers['content-type'] = content_type;
  }

  // add any additional headers passed in
  if (additionalHeaders != null) {
    for (let h of additionalHeaders) {
      headers[h.key] = h.value;
    }
  }

  // the object for the options to return
  let options: Partial<RequestInit> = {
    credentials: credentials,
    method: method,
    headers: headers,
  };
  // BUILD the Body
  if (body != null) {
    if (
      content_type === 'multipart/form-data' ||
      content_type === 'application/octet-stream'
    ) {
      options.body = body;
    } else if (typeof body === 'string') {
      options.body = body;
    } else {
      options.body = JSON.stringify(body);
    }
  }

  return options;
}
